import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BreadcrumbsService } from '@vestiaire/api-sdk-angular';

@Injectable()
export class BreadcrumbService {
  constructor(private router: Router, private breadcrumbsService: BreadcrumbsService) {}

  getBreadcrumb(): Observable<any> {
    let url = this.router.url;
    if (!url.match(/^(?:.*)(?:\/|\.shtml)$/)) {
      // Prevents the lack of '/' at the end of the url
      url = url + '/';
    }

    return this.breadcrumbsService.getBreadcrumb(url);
  }
}
